import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';

export const templateResponsePanelItem = document.createElement('template');

templateResponsePanelItem.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper">
    <div id="actionCategoryName"></div>
    <div id="actions"></div>
  <gz-link id="detailsLink" type="quiet" color="primary" href="" fontsize="11"></gz-link>
  </div>
`;
